import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { BrowserUtils } from "@azure/msal-browser";

export function Logout() {
    const { instance } = useMsal();
    useEffect(() => {
        localStorage.removeItem("USER_ID");
        localStorage.removeItem("USER_EMAIL");
        localStorage.removeItem("USER_FIRSTNAME");
        localStorage.removeItem("USER_LASTNAME");
        localStorage.removeItem("USER_EMPCODE");
        localStorage.removeItem("USER_ROLE_ID");

    }, []);
    useEffect(() => {
        instance.logoutRedirect({
            account: instance.getActiveAccount(),
            onRedirectNavigate: () => !BrowserUtils.isInIframe()
        })

    }, [ instance ]);

    return (
        <div>Logout</div>
    )
}